import { useState, useEffect, useContext } from "react"
import { useHistory } from "react-router-dom"
import { has, isArray } from "lodash"

import { toast } from "react-toastify"

import api from "../../services/api"
import { useSituacaoStore } from "../../stores/situacaoStore"
import toastError from "../../errors/toastError"
import { SocketContext } from "../../context/Socket/SocketContext"
import getTipoDeDispositivo from "../../helpers/getTipoDeDispositivo"
import moment from "moment"
import useConversaRascunhoStore from "../../stores/conversaRascunho"
import { useDashboardStore } from "../../stores/dashboardStore"
import { useTicketsStore } from "../../stores/ticketsStore"
import { useKanbanFiltrosStore } from "../../stores/kanbanFiltrosStore"
import { useRespostaRapidaStore } from "../../stores/respostaRapidaStore"
import { useUsuarioStore } from "../../stores/usuarioStore"
import { useFiltrosKanbanStore } from "../../stores/filtrosKanbanStore"
import Clarity from "@microsoft/clarity"
import { useQueryClient } from "react-query"
import { KANBAN_SITUACOES_QUERY_KEY } from "../kanbanFluxoQueryKeys"

const situacaoCacheSessaoLimpar = (oClienteConsulta) => {
  useSituacaoStore.getState().reiniciar()
  oClienteConsulta?.removeQueries(KANBAN_SITUACOES_QUERY_KEY)
}

const useAuth = () => {
  const history = useHistory()
  const [isAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState({})
  const { rascunhoRemoverTodos } = useConversaRascunhoStore()
  const queryClient = useQueryClient()
  const projectId = "staiaea0my"

  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token")
      if (token) {
        config.headers["Authorization"] = `Bearer ${JSON.parse(token)}`
        setIsAuth(true)
      }
      return config
    },
    (error) => {
      Promise.reject(error)
    },
  )

  api.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      const originalRequest = error.config
      if (error?.response?.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true

        const { data } = await api.post("/auth/refresh_token", {
          tipoDeDispositivo: getTipoDeDispositivo(),
        })
        if (data) {
          localStorage.setItem("token", JSON.stringify(data.token))
          localStorage.setItem("companyId", data.user.companyId)
          localStorage.setItem("userId", data.user.id)
          api.defaults.headers.Authorization = `Bearer ${data.token}`
        }
        return api(originalRequest)
      }
      if (error?.response?.status === 401) {
        situacaoCacheSessaoLimpar(queryClient)
        useDashboardStore.getState().reiniciar()
        useTicketsStore.getState().resetStore()
        localStorage.removeItem("token")
        localStorage.removeItem("companyId")
        useRespostaRapidaStore.getState().reiniciar()
        useUsuarioStore.getState().reiniciar()
        history.push("/login")
        api.defaults.headers.Authorization = undefined
        setIsAuth(false)
      }
      return Promise.reject(error)
    },
  )

  const socketManager = useContext(SocketContext)

  useEffect(() => {
    ;(async () => {
      try {
        const { data } = await api.post("/auth/refresh_token", {
          tipoDeDispositivo: getTipoDeDispositivo(),
        })
        localStorage.setItem("token", JSON.stringify(data.token))
        localStorage.setItem("companyId", data.user.companyId)
        localStorage.setItem("userId", data.user.id)
        api.defaults.headers.Authorization = `Bearer ${data.token}`
        setIsAuth(true)
        setUser(data.user)
      } catch (err) {
        useDashboardStore.getState().reiniciar()
        useTicketsStore.getState().resetStore()
        localStorage.removeItem("token")
        localStorage.removeItem("companyId")
        localStorage.removeItem("userId")
        api.defaults.headers.Authorization = undefined
        setIsAuth(false)
        if (err?.response?.status !== 401) {
          toastError(err)
        }
        if (history.location.pathname !== "/login") {
          history.push("/login")
        }
      }
      setLoading(false)
    })()
  }, [])

  useEffect(() => {
    const companyId = localStorage.getItem("companyId")
    if (companyId) {
      const socket = socketManager.getSocket(companyId)

      socket.on(`company-${companyId}-user`, (data) => {
        if (data.action === "update" && data.user.id === user.id) {
          setUser(data.user)
        }
      })

      return () => {
        socket.disconnect()
      }
    }
  }, [socketManager, user])

  const handleLogin = async (userData) => {
    setLoading(true)

    try {
      const cTipoDeDispositivo = getTipoDeDispositivo()
      const oLoginData = { ...userData, tipoDeDispositivo: cTipoDeDispositivo }

      const { data } = await api.post("/auth/login", oLoginData)

      const {
        user: { companyId, id, company },
      } = data

      if (has(company, "settings") && isArray(company.settings)) {
        const setting = company.settings.find((s) => s.key === "campaignsEnabled")
        if (setting && setting.value === "true") {
          localStorage.setItem("cshow", null) //regra pra exibir campanhas
        }
      }

      moment.locale("pt-br")
      const dueDate = data.user.company.dueDate
      // const hoje = moment(moment()).format("DD/MM/yyyy");
      const vencimento = moment(dueDate).format("DD/MM/yyyy")

      var diff = moment(dueDate).diff(moment(moment()).format())

      var before = moment(moment().format()).isBefore(dueDate)
      var dias = moment.duration(diff).asDays()

      if (before === true) {
        situacaoCacheSessaoLimpar(queryClient)
        localStorage.setItem("token", JSON.stringify(data.token))
        localStorage.setItem("companyId", companyId)
        localStorage.setItem("userId", id)
        localStorage.setItem("companyDueDate", vencimento)
        api.defaults.headers.Authorization = `Bearer ${data.token}`
        setUser(data.user)
        setIsAuth(true)

        Clarity.init(projectId)
        Clarity.identify(id, companyId, "Talk", data.name)
        toast.success("Login efetuado com sucesso!")
        if (Math.round(dias) < 5) {
          toast.warn(`Sua assinatura vence em ${Math.round(dias)} ${Math.round(dias) === 1 ? "dia" : "dias"} `)
        }
        import("../useConversasQueries/prefetchConversasInicial")
          .then(({ prefetchConversasAposLogin }) => prefetchConversasAposLogin())
          .catch(() => {})
        history.push("/conversas")
        setLoading(false)
      } else {
        toastError(`Opss! Sua assinatura venceu ${vencimento}.
        Entre em contato com o Suporte para mais informações! `)
        setLoading(false)
      }

      //quebra linha
    } catch (err) {
      toastError(err)
      setLoading(false)
    }
  }

  const handleLogout = async () => {
    setLoading(true)

    try {
      situacaoCacheSessaoLimpar(queryClient)
      await api.delete("/auth/logout")
      setIsAuth(false)
      setUser({})
      localStorage.removeItem("token")
      localStorage.removeItem("companyId")
      localStorage.removeItem("userId")
      localStorage.removeItem("cshow")
      localStorage.removeItem("ticketFilters")
      useFiltrosKanbanStore.getState().limparFiltros()
      localStorage.clear()
      useDashboardStore.getState().reiniciar()
      useTicketsStore.getState().resetStore()
      useKanbanFiltrosStore.getState().reiniciar()
      rascunhoRemoverTodos()
      useRespostaRapidaStore.getState().reiniciar()
      useUsuarioStore.getState().reiniciar()
      api.defaults.headers.Authorization = undefined
      setLoading(false)
      history.push("/login")
      window.location.reload()
    } catch (err) {
      toastError(err)
      setLoading(false)
    }
  }

  const getCurrentUserInfo = async () => {
    try {
      const { data } = await api.get("/auth/me")
      return data
    } catch (err) {
      toastError(err)
    }
  }

  return {
    isAuth,
    user,
    loading,
    handleLogin,
    handleLogout,
    getCurrentUserInfo,
  }
}

export default useAuth
